import { render } from "./CofounderRanks.vue?vue&type=template&id=8999169c&scoped=true&ts=true"
import script from "./CofounderRanks.vue?vue&type=script&lang=ts"
export * from "./CofounderRanks.vue?vue&type=script&lang=ts"

import "./CofounderRanks.vue?vue&type=style&index=0&id=8999169c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8999169c"]])

export default __exports__